const features = [
  {
    icon: 'ri-flashlight-line',
    title: 'Faster Product Sourcing',
    description: 'The Mulebuy Spreadsheet workflow dramatically reduces time spent searching and comparing products. Organize everything in one structured system for rapid decision-making.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Price Comparison Made Easy',
    description: 'Compare supplier prices side-by-side within your spreadsheet. The Mulebuy Spreadsheet method helps you spot the best deals and avoid overpaying on cross-border purchases.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Organized & Reliable Tracking',
    description: 'Keep every order, supplier detail, and shipping update neatly organized. The spreadsheet-based approach eliminates confusion and reduces shopping errors significantly.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="px-6 md:px-10">
        <div className="mb-14 md:mb-20">
          <span className="text-xs font-medium tracking-wider uppercase text-foreground-400 font-label">Why Choose Us</span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-[1.12] mt-3 tracking-tight">
            Why Mulebuy
            <br />
            Spreadsheet Works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-8">
          {features.map((feat) => (
            <div key={feat.title} className="bg-background-50 rounded-2xl p-8 md:p-10">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${feat.icon} text-3xl text-primary-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-foreground-950 mb-4">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 md:mt-20 bg-background-50 rounded-2xl p-6 md:p-10 overflow-x-auto">
          <h3 className="text-lg font-bold text-foreground-950 mb-6">Mulebuy Spreadsheet vs Traditional Methods</h3>
          <table className="w-full min-w-[600px]">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-700">Feature</th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-primary-500">Mulebuy Spreadsheet</th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-500">Traditional Agents</th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-500">Manual Sourcing</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70">
                <td className="py-3.5 px-4 text-sm text-foreground-700 font-medium">Speed</td>
                <td className="py-3.5 px-4 text-sm text-primary-600 font-semibold">Fast</td>
                <td className="py-3.5 px-4 text-sm text-foreground-600">Medium</td>
                <td className="py-3.5 px-4 text-sm text-foreground-600">Slow</td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-3.5 px-4 text-sm text-foreground-700 font-medium">Organization</td>
                <td className="py-3.5 px-4 text-sm text-primary-600 font-semibold">High</td>
                <td className="py-3.5 px-4 text-sm text-foreground-600">Medium</td>
                <td className="py-3.5 px-4 text-sm text-foreground-600">Low</td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-3.5 px-4 text-sm text-foreground-700 font-medium">Cost Control</td>
                <td className="py-3.5 px-4 text-sm text-primary-600 font-semibold">High</td>
                <td className="py-3.5 px-4 text-sm text-foreground-600">Medium</td>
                <td className="py-3.5 px-4 text-sm text-foreground-600">Low</td>
              </tr>
              <tr>
                <td className="py-3.5 px-4 text-sm text-foreground-700 font-medium">Ease of Use</td>
                <td className="py-3.5 px-4 text-sm text-primary-600 font-semibold">Easy</td>
                <td className="py-3.5 px-4 text-sm text-foreground-600">Moderate</td>
                <td className="py-3.5 px-4 text-sm text-foreground-600">Hard</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}